import {lazyRegister} from "@core/lazyRegister";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class TokenService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    createOtpByType(type: string, langCode: string, accessToken: string = null,
                    cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<boolean>('/v2/api/otp/' + type, {
            langCode
        }, cancelToken, accessToken ? {
            accessToken: accessToken
        } : null);
    }
}

lazyRegister.service('TokenService', TokenService);
